import { AxiosError } from 'axios'

import { transformBackendResponseKey } from '@/config'
import { TTranslationFunction } from '@/types'

export const getValidErrorMessage = (
	error: unknown,
	t: TTranslationFunction,
): string => {
	let errorMessage = (error as { message: string }).message || ''

	if (error instanceof Error) {
		errorMessage = error.message
	}

	if ((error as { cause: unknown }).cause === 'SubscriptionCancellation') {
		errorMessage = t((error as { message: string }).message)
	}

	if (error instanceof AxiosError) {
		const message =
			(error.response?.data as { errorMessage: string })?.errorMessage ||
			(error.response?.data as { message: string })?.message
		const translationKey = Array.isArray(message) ? message[0] : message
		const transformedKeyName = transformBackendResponseKey(translationKey)
		errorMessage = t(transformedKeyName)
	}

	return errorMessage
}
